const getDisplayTitle = (fhirJson, parentResourceDetail) => {
    if (fhirJson) {
        if (fhirJson.title && fhirJson.title.trim()) {
            return fhirJson.title.trim();
        }
        if (fhirJson.name) {
            if (typeof fhirJson.name === "string") {
                if (fhirJson.name.trim()) {
                    return fhirJson.name.trim();
                }
            } else if (Array.isArray(fhirJson.name) && fhirJson.name[0]?.text && fhirJson.name[0].text.trim()) {
                return fhirJson.name[0].text.trim();
            }
        }
    }
    if (parentResourceDetail?.displayTitle) {
        return parentResourceDetail.displayTitle;
    }
    return "UNTITLED RESOURCE";
}

export default getDisplayTitle;